import {
  Globe, Heart, Smile, FileText, Share2, Link
} from 'lucide-react';

export const PERSONAL_SECTIONS = [
  {
    id: "languages",
    title: "Languages",
    icon: Globe,
    category: "personal",
    allowMultiple: true,
    defaultVisible: false,
    emptyState: "No languages added yet.",
    editorComponent: "GenericListEditor",
    rendererComponent: "GenericListRenderer",
    layout: {
      preferredColumn: "main",
      priority: 45,
      collapsible: true,
      allowPageBreak: false,
      keepTogether: true,
    },
    capabilities: {
      aiRewrite: false,
      reorder: true,
      duplicate: true,
      deletable: true,
      hideable: true,
      exportable: true,
    },
    recommendedFor: ["all"],
    badges: ["Recommended"],
    fields: [
      { name: "language", label: "Language", type: "text", required: true, placeholder: "e.g. Spanish" },
      { name: "proficiency", label: "Proficiency Level", type: "text", required: true, placeholder: "e.g. Native, Fluent, Conversational" }
    ],
    defaultData: { language: "", proficiency: "" }
  },
  {
    id: "interests",
    title: "Interests",
    icon: Heart,
    category: "personal",
    allowMultiple: true,
    defaultVisible: false,
    emptyState: "No interests added yet.",
    editorComponent: "InterestsEditor",
    rendererComponent: "TagListRenderer",
    layout: {
      preferredColumn: "main",
      priority: 40,
      collapsible: true,
      allowPageBreak: false,
      keepTogether: true,
    },
    capabilities: {
      aiRewrite: false,
      reorder: false,
      duplicate: false,
      deletable: false,
      hideable: true,
      exportable: true,
    },
    recommendedFor: ["all"],
    badges: [],
    fields: [
      { name: "interests", label: "Interests List", type: "tag", required: true, placeholder: "e.g. Chess, Web3, Astronomy..." }
    ]
  },
  {
    id: "hobbies",
    title: "Hobbies",
    icon: Smile,
    category: "personal",
    allowMultiple: true,
    defaultVisible: false,
    emptyState: "No hobbies added yet.",
    editorComponent: "InterestsEditor",
    rendererComponent: "TagListRenderer",
    layout: {
      preferredColumn: "main",
      priority: 35,
      collapsible: true,
      allowPageBreak: false,
      keepTogether: true,
    },
    capabilities: {
      aiRewrite: false,
      reorder: false,
      duplicate: false,
      deletable: false,
      hideable: true,
      exportable: true,
    },
    recommendedFor: ["all"],
    badges: [],
    fields: [
      { name: "hobbies", label: "Hobbies List", type: "tag", required: true, placeholder: "e.g. Photography, Hiking, Reading..." }
    ]
  },
  {
    id: "references",
    title: "References",
    icon: FileText,
    category: "personal",
    allowMultiple: true,
    defaultVisible: false,
    emptyState: "No references added yet.",
    editorComponent: "GenericListEditor",
    rendererComponent: "GenericListRenderer",
    layout: {
      preferredColumn: "main",
      priority: 30,
      collapsible: true,
      allowPageBreak: true,
      keepTogether: true,
    },
    capabilities: {
      aiRewrite: false,
      reorder: true,
      duplicate: true,
      deletable: true,
      hideable: true,
      exportable: true,
    },
    recommendedFor: ["all"],
    badges: [],
    fields: [
      { name: "name", label: "Reference Name", type: "text", required: true, placeholder: "e.g. Dr. Sarah Jenkins" },
      { name: "company", label: "Title / Organization", type: "text", required: true, placeholder: "e.g. Director at Stanford AI Lab" },
      { name: "contact_info", label: "Contact Info / Phone / Email", type: "text", required: true, placeholder: "e.g. sarah.j@stanford.edu or 555-0192" }
    ],
    defaultData: { name: "", company: "", contact_info: "" }
  },
  {
    id: "social_profiles",
    title: "Social Profiles",
    icon: Share2,
    category: "personal",
    allowMultiple: true,
    defaultVisible: false,
    emptyState: "No social profiles added yet.",
    editorComponent: "GenericListEditor",
    rendererComponent: "GenericListRenderer",
    layout: {
      preferredColumn: "main",
      priority: 25,
      collapsible: true,
      allowPageBreak: false,
      keepTogether: true,
    },
    capabilities: {
      aiRewrite: false,
      reorder: true,
      duplicate: true,
      deletable: true,
      hideable: true,
      exportable: true,
    },
    recommendedFor: ["all"],
    badges: ["Recommended"],
    fields: [
      { name: "network", label: "Network / Platform", type: "text", required: true, placeholder: "e.g. LeetCode, Behance, Dribbble" },
      { name: "username", label: "Username / Handle", type: "text", required: true, placeholder: "e.g. dev_arjun" },
      { name: "url", label: "URL Link", type: "url", required: true, placeholder: "e.g. https://leetcode.com/dev_arjun" }
    ],
    defaultData: { network: "", username: "", url: "" }
  },
  {
    id: "portfolio",
    title: "Portfolio Projects",
    icon: Link,
    category: "personal",
    allowMultiple: true,
    defaultVisible: false,
    emptyState: "No portfolio projects added yet.",
    editorComponent: "GenericListEditor",
    rendererComponent: "GenericListRenderer",
    layout: {
      preferredColumn: "main",
      priority: 20,
      collapsible: true,
      allowPageBreak: true,
      keepTogether: false,
    },
    capabilities: {
      aiRewrite: true,
      reorder: true,
      duplicate: true,
      deletable: true,
      hideable: true,
      exportable: true,
    },
    recommendedFor: ["creative", "ui-ux-designer"],
    badges: [],
    fields: [
      { name: "title", label: "Project Title", type: "text", required: true, placeholder: "e.g. Dynamic Dashboards Case Study" },
      { name: "url", label: "Project URL / Link", type: "url", required: true, placeholder: "e.g. https://dribbble.com/shots/..." },
      { name: "description", label: "Case Study / Overview", type: "textarea", required: false, placeholder: "Details on user testing, wireframing, and Figma prototypes..." }
    ],
    defaultData: { title: "", url: "", description: "" }
  }
];
